import * as React from "react";
import { Navbar } from "components/Navbar";
import ErrorPanel from "components/ErrorPanel";
import RootRoutes from "../RootRoutes";
import GettingStartedFooter from "../GettingStarted/GettingStartedFooter";
import { UnhandledError } from "globalState";
import SystemMessagesBanner from "components/SystemMessagesBanner/SystemMessagesBanner";
import Sticky from "components/Sticky/Sticky";
import {client} from "../../clientInstance";

interface StandardLayoutProps {
    versionText: string;
    unhandledError: UnhandledError;
    onErrorClose(): void;
}

export default class StandardLayoutInternal extends React.Component<StandardLayoutProps> {
    render() {
        return <div>
            <Sticky innerZ={10}>
                <div id="toppanel">
                    <Navbar />
                    {this.props.unhandledError &&
                        <ErrorPanel message={`An unexpected error occurred in Octopus v${client.version}: ${this.props.unhandledError.message}`}
                                    details={this.props.unhandledError.details}
                                    fullWidth={true}
                                    canClose={true}
                                    onErrorClose={this.onErrorClose} />}
                    <SystemMessagesBanner />
                </div>
            </Sticky>
            <RootRoutes />
            <GettingStartedFooter />
        </div>;
    }

    private onErrorClose = () => {
        this.props.onErrorClose();
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/StandardLayout/StandardLayoutInternal.tsx